import React, { useEffect } from "react";
import Swal from "sweetalert2";
import axios from "axios";

const AddUomModal = ({ isAddOpen, onAddClose, formData, setFormData, fetchData, user, branch }) => {
  // ✅ Fetch new UOM code when modal opens
  useEffect(() => {
    const fetchUomNo = async () => {
      try {
        const response = await axios.get("https://rfs2.infraconsoft.net.in/api/uomMaster_addNo");
        if (response.data.no) {
          setFormData({
            code: response.data.no,
            name: "",
            longName: "",
            user,
            branch,
          });
        }
      } catch (error) {
        console.error("Error fetching UOM Number:", error);
      }
    };

    if (isAddOpen) {
      fetchUomNo();
    }
  }, [isAddOpen, setFormData, user, branch]);

  if (!isAddOpen) return null;

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    // === Validation ===
    if (!formData.code || formData.code.trim() === "") {
      Swal.fire("Validation Error", "UOM Code should not be empty.", "warning");
      return;
    }
    if (!formData.name || formData.name.trim() === "") {
      Swal.fire("Validation Error", "UOM Name should not be empty.", "warning");
      return;
    }
    if (!formData.longName || formData.longName.trim() === "") {
      Swal.fire("Validation Error", "Long Name should not be empty.", "warning");
      return;
    }

    try {
      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const response = await axios.post("https://rfs2.infraconsoft.net.in/api/uomMaster_insert", {
        code: formData.code,
        name: formData.name,
        longName: formData.longName,
        user,
        branch,
      });

      if (response.data.success) {
        Swal.fire("Inserted!", "Inserted successfully.", "success");

        // ✅ Fetch next UOM code for next insert
        const newCodeRes = await axios.get("https://rfs2.infraconsoft.net.in/api/uomMaster_addNo");
        setFormData({
          code: newCodeRes.data.no,
          name: "",
          longName: "",
          user,
          branch,
        });

        onAddClose();
        fetchData();
      }
    } catch (error) {
      console.error("Error inserting UOM:", error);

      if (error.response && error.response.status === 400) {
        Swal.fire("Already Exists", error.response.data.message, "error");
      } else {
        Swal.fire("Error", "Insertion failed. Please try again.", "error");
      }
    }
  };

  return (
    <div className="modal">
      <div className="modal-content" style={{ position: "relative" }}>
        <div style={{ position: "absolute", top: "10px", right: "10px" }}>
          <button className="close-btn" onClick={onAddClose} style={{ position: "initial" }}>
            &times;
          </button>
        </div>
        <h3>Add New Unit Of Measurement</h3>
        <form className="vehicle-form" onSubmit={handleEditSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>UOM Code :</label>
              <input type="text" name="code" value={formData.code || ""} readOnly />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>UOM Short Name :</label>
              <input
                type="text"
                name="name"
                value={formData.name || ""}
                onChange={handleEditChange}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>UOM Long Name :</label>
              <input
                type="text"
                name="longName"
                value={formData.longName || ""}
                onChange={handleEditChange}
              />
            </div>
          </div>

          <div className="btn-cls">
            <button type="submit" className="submit-btn">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUomModal;
